import React, {  } from 'react';

import { collateOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { CompareInput } from './Intl.Collator';

export const IntlCollatorCompare = () => (
	<IntlFunction
		input={CompareInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/compare"
		header="Intl.Collator.prototype.compare"
		description="Compares two strings according to the sort order of this [Intl.Collator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator) object."
		options={collateOptions}
		ruleSet={[]}
		template="new Intl.Collator(##locale##, ##options##).compare(##input##, ##input##)" />
)